export default "__VITE_ASSET__fbb95c98__"